<template>
  <div id="profile-sidebar-parent">
    <vs-sidebar
      ref="sidebar"
      v-model="active"
      default-index="1"
      position-right
      color="primary"
      class="short-profile short-profile-popup"
      spacer
      parent="#app"
      @input="onAction"
    >
      <template v-if="applicant">
        <div
          v-if="applicant.firstName && applicant.lastName"
          slot="header"
          class="header-sidebar"
        >
          <h4 id="user-name">
            <span>
              <template v-if="applicant.salutation == `MR`">Herr</template>
              <template v-else-if="applicant.salutation == `MRS`"
                >Frau</template
              >
              <template v-else>-</template>
            </span>
            <br />
            {{ applicant.firstName }} {{ applicant.lastName }}
            <template v-if="applicant.birthday">({{ age }})</template>
          </h4>
        </div>
        <div id="user-infos" class="divide-y divide-gray">
          <div class="short-profile-value">
            <span class="short-profile-value-label"
              ><i class="fad fa-file-alt"></i> Beworben als:</span
            >
            <template v-if="applicant.defaultProfile.wantedOccupation">{{
              applicant.defaultProfile.wantedOccupation
            }}</template>
            <template v-else>Keine Angabe</template>
          </div>
          <div
            v-if="applicant.contactData && applicant.contactData.address"
            class="short-profile-value"
          >
            <span class="short-profile-value-label"
              ><i class="fad fa-home"></i> Wohnort:</span
            >
            {{ applicant.contactData.address.street }}<br />
            {{ applicant.contactData.address.zip }}
            {{ applicant.contactData.address.city }}
          </div>
          <!-- <div class="short-profile-value">
            <span class="short-profile-value-label"
              ><i class="fad fa-clock"></i> Anstellungsart:</span
            >
            VZ oder TZ
          </div>
          <div class="short-profile-value">
            <span class="short-profile-value-label"
              ><i class="fad fa-handshake-alt"></i> Vermittlungsart:</span
            >
            AÜ oder PV
          </div> -->
          <template v-if="applicant.defaultProfile">
            <div class="short-profile-value">
              <span class="short-profile-value-label"
                ><i class="fad fa-car"></i> PKW:</span
              >
              <template v-if="applicant.defaultProfile.ownCar">Ja</template>
              <template v-else>Nein</template>
            </div>
            <div class="short-profile-value">
              <span class="short-profile-value-label"
                ><i class="fad fa-calendar-alt"></i> Verfügbar ab:</span
              >
              <template v-if="applicant.defaultProfile.availibiltyCustom">{{
                applicant.defaultProfile.availibiltyCustom
              }}</template>
              <template v-else-if="applicant.defaultProfile.availibilty">{{
                applicant.defaultProfile.availibilty.name
              }}</template>
              <template v-else>Keine Angabe</template>
            </div>
          </template>
          <template v-if="applicant.contactData">
            <div class="short-profile-value">
              <span class="short-profile-value-label"
                ><i class="fad fa-phone-alt"></i> Telefon:</span
              >
              <a
                v-if="applicant.contactData.telephone"
                :href="`callto:${applicant.contactData.telephone}`"
                >{{ applicant.contactData.telephone }}</a
              >
              <template v-else>Keine Angabe</template>
            </div>
            <div class="short-profile-value">
              <span class="short-profile-value-label"
                ><i class="fad fa-envelope"></i> E-Mail:</span
              >

              <a
                v-if="applicant.contactData.email"
                :href="`mailto:${applicant.contactData.email}`"
                >{{ applicant.contactData.email }}</a
              >
              <template v-else>Keine Angabe</template>
            </div>
            <div class="short-profile-value">
              <span class="short-profile-value-label"
                ><i class="fad fa-envelope"></i> Status:</span
              >

              <template v-if="applicant.defaultProfile.state">{{
                applicant.defaultProfile.state.name
              }}</template>
              <template v-else>Keine Angabe</template>
            </div>
          </template>
          <template>
            <div class="short-profile-value">
              <span class="short-profile-value-label"
                ><i class="fad fa-euro-sign"></i> Wunschgehalt:</span
              >

              <template v-if="applicant.defaultProfile.salaryWanted"
                >{{ applicant.defaultProfile.salaryWanted }} €</template
              >
              <template v-else>Keine Angabe</template>
            </div>
          </template>
        </div>
        <div slot="footer" class="footer-sidebar">
          <vs-button
            v-if="applicant.contactData.telephone"
            id="preview-phone"
            color="primary"
            type="filled"
            :href="`callto:` + applicant.contactData.telephone"
            ><i class="fas fa-phone-alt"></i> Telefon</vs-button
          >
          <vs-button
            v-if="applicant.contactData.email"
            id="preview-mail"
            color="primary"
            type="filled"
            :href="`mailto:` + applicant.contactData.email"
            ><i class="fas fa-envelope"></i> E-Mail</vs-button
          >
        </div>
      </template>
    </vs-sidebar>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";

export default {
  data() {
    return {
      active: false,
      age: ""
    };
  },
  apollo: {
    applicant: {
      query: gql`
        query Applicant($id: ID!) {
          applicant(id: $id) {
            id
            salutation
            firstName
            lastName
            birthday
            defaultProfile {
              id
              ownCar
              availibilty {
                id
                name
              }
              state {
                id
                name
              }
              availibiltyCustom
              wantedOccupation
              salaryWanted
            }
            contactData {
              email
              telephone
              telephoneMobile
              address {
                street
                country
                zip
                city
              }
            }
          }
        }
      `,
      skip() {
        return !this.$route.params.previewid;
      },
      variables() {
        return {
          id: this.$route.params.previewid
        };
      }
    }
  },
  watch: {
    "$route.params.previewid": {
      handler(v) {
        if (v) {
          this.active = true;
          setTimeout(() => {
            this.getAge();
          }, 300);
        } else {
          this.active = false;
        }
      }
    }
  },
  async beforeDestroy() {
    const el = document.querySelector(".short-profile-popup");

    if (el) {
      el.remove();
    }
  },
  mounted() {
    if (this.$route.params.previewid) {
      this.$nextTick().then(() => {
        this.active = true;
      });
    }
  },
  methods: {
    getAge() {
      if (this.applicant.birthday) {
        this.age = moment().diff(this.applicant.birthday, "years", false);
      }
    },
    onAction(v) {
      if (!v) {
        this.$router.replace({
          name: this.$route.params.referer || "applicant.overview",
          params: {
            ...(this.$route.params.refererParams || {})
          }
        });
      }
    }
  }
};
</script>
